// @ts-nocheck
// Shared helpers for file cards across files-search and predictive-search
// Safely define globals without clobbering existing implementations
(function () {
  try {
    window.FileUtils = window.FileUtils || {};
    window.FilesSearchAPI = window.FilesSearchAPI || {};

    const triggerNativeDownload = (href, filename) => {
      const a = document.createElement('a');
      a.href = href;
      if (filename) a.setAttribute('download', filename);
      a.rel = 'noopener noreferrer';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      a.remove();
    };

    // Minimal HTML escaper
    if (typeof window.FileUtils.escapeHtml !== 'function') {
      window.FileUtils.escapeHtml = function (str) {
        if (str == null) return '';
        return String(str)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      };
    }

    // File name from URL
    if (typeof window.FileUtils.getFileNameFromUrl !== 'function') {
      window.FileUtils.getFileNameFromUrl = function (url) {
        try {
          const urlObj = new URL(url, window.location.href);
          const fileName = (urlObj.pathname || '').split('/').pop();
          const decoded = decodeURIComponent(fileName || 'download');
          const normalized =
            window.FileUtils && typeof window.FileUtils.normalizeIesDownloadName === 'function'
              ? window.FileUtils.normalizeIesDownloadName(decoded)
              : decoded;
          return normalized.length > 50 ? normalized.substring(0, 47) + '...' : normalized;
        } catch (e) {
          return 'download';
        }
      };
    }

    // Extension from URL
    if (typeof window.FileUtils.getFileExtension !== 'function') {
      window.FileUtils.getFileExtension = function (url) {
        try {
          const fileName = String(url).split('/').pop().split('?')[0];
          const ext = fileName.split('.').pop().toLowerCase();
          return ext || 'file';
        } catch (e) {
          return 'file';
        }
      };
    }

    // SVG doc icon generator
    if (typeof window.FileUtils.getDocIconSvg !== 'function') {
      window.FileUtils.getDocIconSvg = function (kind, extLabel, iconUrl) {
        const escapeHtml = window.FileUtils.escapeHtml;

        // 1. Prefer explicit iconUrl if provided
        // 2. Fallback to global window.fileIcons config if available
        let finalIconUrl = iconUrl;

        if (!finalIconUrl && window.fileIcons) {
          if (kind === 'pdf' || kind === 'manual') finalIconUrl = window.fileIcons.manual;
          else if (kind === 'spec') finalIconUrl = window.fileIcons.spec;
          else if (kind === 'ies') finalIconUrl = window.fileIcons.ies;
          else if (kind === 'revit') finalIconUrl = window.fileIcons.revit;
          else finalIconUrl = window.fileIcons.ext; // Generic fallback
        }

        // If we found an image URL, render it
        if (finalIconUrl) {
          const kindLower = String(kind || '').toLowerCase();
          const kindClass =
            kindLower === 'pdf' || kindLower === 'manual'
              ? 'pdf'
              : kindLower === 'spec'
                ? 'spec'
                : kindLower === 'ies'
                  ? 'ies'
                  : kindLower === 'revit'
                    ? 'revit'
                    : 'ext';
          const altText =
            kindClass === 'ext'
              ? escapeHtml(String(extLabel || 'FILE').toUpperCase())
              : escapeHtml(kindClass.toUpperCase());
          return (
            '<img src="' +
            escapeHtml(finalIconUrl) +
            '" class="doc-icon doc-icon-img doc-icon--' +
            escapeHtml(kindClass) +
            '" alt="' +
            altText +
            '" width="105" height="105" loading="lazy" />'
          );
        }

        return '';
      };
    }

    // Parse Content-Disposition filename (RFC 5987)
    if (typeof window.FileUtils.parseContentDispositionFilename !== 'function') {
      window.FileUtils.parseContentDispositionFilename = function (header) {
        if (!header || typeof header !== 'string') return null;
        try {
          const parts = header.split(';').map(p => p.trim());
          let filenameStar = null;
          let filenameSimple = null;
          for (const part of parts) {
            const lower = part.toLowerCase();
            if (lower.startsWith('filename*=')) {
              filenameStar = part.substring(part.indexOf('=') + 1);
            } else if (lower.startsWith('filename=')) {
              filenameSimple = part.substring(part.indexOf('=') + 1);
            }
          }
          if (filenameStar) {
            let value = filenameStar.replace(/^"(.*)"$/, '$1');
            const idx = value.indexOf("''");
            let encoded = idx >= 0 ? value.substring(idx + 2) : value;
            try {
              const decoded = decodeURIComponent(encoded);
              return decoded.replace(/[\/\\]/g, '').replace(/\0/g, '');
            } catch (e) {
              return encoded.replace(/[\/\\]/g, '').replace(/\0/g, '');
            }
          }
          if (filenameSimple) {
            let value = filenameSimple.replace(/^"(.*)"$/, '$1');
            try {
              value = decodeURIComponent(value);
            } catch (e) {}
            return value.replace(/[\/\\]/g, '').replace(/\0/g, '');
          }
          return null;
        } catch (e) {
          return null;
        }
      };
    }

    // Shopify hosts some IES assets as *.ies.txt; this normalizes saved names to *.ies.
    if (typeof window.FileUtils.normalizeIesDownloadName !== 'function') {
      window.FileUtils.normalizeIesDownloadName = function (name) {
        try {
          const str = String(name || '');
          const lower = str.toLowerCase();
          if (lower.endsWith('.ies.txt')) return str.slice(0, -4);
          return str;
        } catch (e) {
          return name || '';
        }
      };
    }

    if (typeof window.FileUtils.toIesUrl !== 'function') {
      window.FileUtils.toIesUrl = function (url) {
        try {
          const parsed = new URL(url, window.location.href);
          const lowerPath = String(parsed.pathname || '').toLowerCase();
          if (!lowerPath.endsWith('.ies.txt')) return parsed.href;
          parsed.pathname = parsed.pathname.slice(0, -4);
          return parsed.href;
        } catch (e) {
          return url || '';
        }
      };
    }

    // Requests IES from the server using the current hosted form (*.ies.txt).
    if (typeof window.FileUtils.toIesTxtUrl !== 'function') {
      window.FileUtils.toIesTxtUrl = function (url) {
        try {
          const parsed = new URL(url, window.location.href);
          const lowerPath = String(parsed.pathname || '').toLowerCase();
          if (lowerPath.endsWith('.ies.txt')) return parsed.href;
          if (lowerPath.endsWith('.ies')) {
            parsed.pathname = parsed.pathname + '.txt';
            return parsed.href;
          }
          return parsed.href;
        } catch (e) {
          return url || '';
        }
      };
    }

    if (typeof window.FileUtils.normalizeIesUrl !== 'function') {
      window.FileUtils.normalizeIesUrl = function (url) {
        return window.FileUtils && typeof window.FileUtils.toIesUrl === 'function'
          ? window.FileUtils.toIesUrl(url)
          : url || '';
      };
    }

    if (typeof window.FileUtils.isIesFile !== 'function') {
      window.FileUtils.isIesFile = function (url, type) {
        try {
          const typeLower = String(type || '').toLowerCase();
          if (typeLower.includes('ies')) return true;
          const urlLower = String(url || '').toLowerCase();
          return urlLower.includes('.ies');
        } catch (e) {
          return false;
        }
      };
    }

    if (typeof window.FilesSearchAPI.downloadFile !== 'function') {
      window.FilesSearchAPI.downloadFile = async function (opts) {
        const options = opts || {};
        const requestUrl = String(options.requestUrl || '');
        const downloadName = String(options.downloadName || '');
        if (!requestUrl) return;
        try {
          triggerNativeDownload(requestUrl, downloadName);
        } catch (e) {
          window.location.href = requestUrl;
        }
      };
    }

    if (typeof window.FilesSearchAPI.downloadIesAsIes !== 'function') {
      window.FilesSearchAPI.downloadIesAsIes = async function (urlStr, opts) {
        const options = opts || {};
        const timeoutMs = Number.isFinite(options.timeoutMs) ? options.timeoutMs : 20000;
        const maxBlobBytes = Number.isFinite(options.maxBlobBytes)
          ? options.maxBlobBytes
          : 10 * 1024 * 1024;

        const requestUrl =
          window.FileUtils && typeof window.FileUtils.toIesTxtUrl === 'function'
            ? window.FileUtils.toIesTxtUrl(urlStr)
            : String(urlStr || '');

        const rawName =
          options.suggestedName ||
          (window.FileUtils && typeof window.FileUtils.getFileNameFromUrl === 'function'
            ? window.FileUtils.getFileNameFromUrl(requestUrl)
            : 'download.ies');

        let downloadName =
          window.FileUtils && typeof window.FileUtils.normalizeIesDownloadName === 'function'
            ? window.FileUtils.normalizeIesDownloadName(rawName)
            : rawName;

        if (downloadName && !String(downloadName).toLowerCase().endsWith('.ies')) {
          downloadName = String(downloadName).replace(/\.+$/, '') + '.ies';
        }

        const notifyError = detail => {
          try {
            if (typeof options.onError === 'function') options.onError(detail);
          } catch (e) {}
        };

        if (!requestUrl) return;

        // Purpose: Shopify hosts IES assets as cross-origin `*.ies.txt`. Most browsers ignore `download="*.ies"`
        // on cross-origin links. Fetching + downloading an object URL makes the browser honor the filename.
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), timeoutMs);
        const signal = options.signal || controller.signal;

        try {
          const response = await fetch(requestUrl, { mode: 'cors', signal });
          if (!response.ok) throw new Error(`http_${response.status}`);

          const contentType = (response.headers.get('content-type') || '').toLowerCase();
          if (contentType.includes('text/html')) throw new Error('unexpected_html');

          const totalBytes = parseInt(response.headers.get('content-length') || '0', 10) || null;
          if (totalBytes && totalBytes > maxBlobBytes) throw new Error('too_large');

          const blob = await response.blob();
          if (blob.size > maxBlobBytes) throw new Error('too_large');

          const blobUrl = URL.createObjectURL(blob);
          triggerNativeDownload(blobUrl, downloadName);
          setTimeout(() => URL.revokeObjectURL(blobUrl), 2000);
        } catch (err) {
          notifyError({
            reason: err && err.name === 'AbortError' ? 'timeout' : 'download_failed',
            url: requestUrl,
            error: String((err && err.message) || err),
          });

          // Fallback: still try native anchor download (may save as .ies.txt on some browsers).
          try {
            triggerNativeDownload(requestUrl, downloadName);
          } catch (e2) {
            window.location.href = requestUrl;
          }
        } finally {
          clearTimeout(timeoutId);
        }
      };
    }

    if (typeof window.FilesSearchAPI.downloadIes !== 'function') {
      window.FilesSearchAPI.downloadIes = function (urlStr, opts) {
        return window.FilesSearchAPI.downloadIesAsIes(urlStr, opts);
      };
    }

    if (typeof window.FilesSearchAPI.secureDownload !== 'function') {
      // Routes IES to the IES-only download path so the anchor suggestedName is respected.
      window.FilesSearchAPI.secureDownload = function (urlStr, suggestedName, onError) {
        const isIes =
          window.FileUtils && typeof window.FileUtils.isIesFile === 'function'
            ? window.FileUtils.isIesFile(urlStr)
            : String(urlStr || '')
                .toLowerCase()
                .includes('.ies');
        if (
          isIes &&
          window.FilesSearchAPI &&
          typeof window.FilesSearchAPI.downloadIesAsIes === 'function'
        ) {
          return window.FilesSearchAPI.downloadIesAsIes(urlStr, { onError, suggestedName });
        }
        const requestUrl = String(urlStr || '');
        const baseName =
          suggestedName ||
          (window.FileUtils && typeof window.FileUtils.getFileNameFromUrl === 'function'
            ? window.FileUtils.getFileNameFromUrl(requestUrl)
            : 'download');
        return window.FilesSearchAPI.downloadFile({ requestUrl, downloadName: baseName, onError });
      };
    }

    if (typeof window.FilesSearchAPI.handleFileLinkClick !== 'function') {
      window.FilesSearchAPI.handleFileLinkClick = function (event, opts) {
        try {
          const e = event;
          const containerOpenInBrowser = !!(opts && opts.openInBrowser);
          const target = e && e.target;
          const anchor = target && target.closest ? target.closest('.file-download-link') : null;
          if (!anchor) return;

          if (e && e.__filesSearchDownloadHandled) return;
          if (e) e.__filesSearchDownloadHandled = true;

          const href =
            anchor.getAttribute('data-original-href') || anchor.getAttribute('href') || '';
          const downloadAttr = anchor.getAttribute('download') || '';
          const isIes =
            window.FileUtils && typeof window.FileUtils.isIesFile === 'function'
              ? window.FileUtils.isIesFile(href)
              : String(href || '')
                  .toLowerCase()
                  .includes('.ies');
          const forceDownload = isIes;

          const linkOpenInBrowser = anchor.getAttribute('data-open-in-browser') === 'true';
          const openInBrowser = linkOpenInBrowser || containerOpenInBrowser;
          if (openInBrowser && !forceDownload) return;

          if (e && typeof e.preventDefault === 'function') e.preventDefault();
          if (window.FilesSearchAPI && typeof window.FilesSearchAPI.secureDownload === 'function') {
            window.FilesSearchAPI.secureDownload(href, downloadAttr);
            return;
          }

          const tmpLink = document.createElement('a');
          tmpLink.href = href;
          if (downloadAttr) tmpLink.setAttribute('download', downloadAttr);
          tmpLink.rel = 'noopener noreferrer';
          tmpLink.style.display = 'none';
          document.body.appendChild(tmpLink);
          tmpLink.click();
          tmpLink.remove();
        } catch (err) {}
      };
    }
  } catch (e) {
    console.warn('files-card-helpers initialization failed:', e);
  }
})();
